module.exports = __webpack_public_path__ + "img/vendlet02.e8613f56.jpeg";